import React from 'react';
import css from './Sections.module.css';
import { H3 } from '../../../components';
import { REVIEW_TYPE_OF_PROVIDER } from '../../../util/types';

const SectionMemberStats = props => {
  const { reviews, checkIns = [], intl } = props;
  const reviewsOfProvider = (reviews || []).filter(
    r => r?.attributes?.type === REVIEW_TYPE_OF_PROVIDER
  );
  const checkInCount = Array.isArray(checkIns) ? checkIns.length : 0;

  const totalRatings = reviewsOfProvider.reduce(
    (sum, review) => sum + (review?.attributes?.rating || 0),
    0
  );
  const rating = reviewsOfProvider.length > 0 ? totalRatings / reviewsOfProvider.length : 0;

  return (
    <div className={css.memberStatsSection}>
      <H3 className={css.captainsLogTitle}>
        {intl.formatMessage({ id: 'ProfilePage.SectionMemberStats.heading' })}
      </H3>
      <div className={css.statsContainer}>
        <div className={css.statItem}>
          <span className={css.statValue}>{checkInCount}</span>
          <span className={css.statLabel}>
            {intl.formatMessage({ id: 'ProfilePage.SectionMemberStats.checkIns' })}
          </span>
        </div>
        <div className={css.statItem}>
          <span className={css.statValue}>
            {intl.formatNumber(rating, { minimumFractionDigits: 1, maximumFractionDigits: 1 })}
          </span>
          <span className={css.statLabel}>
            {intl.formatMessage({ id: 'ProfilePage.SectionMemberStats.rating' })}
          </span>
        </div>
      </div>
    </div>
  );
};

export default SectionMemberStats;
